import { jsx as x } from "react/jsx-runtime";
import { initDB as R } from "@pufflig/promptbook-db";
import { initStorage as S } from "@pufflig/promptbook-storage";
import { useQuery as i } from "@tanstack/react-query";
import { createContext as k, useState as w, useRef as F, useEffect as C, useMemo as q, useContext as v } from "react";
const c = k(null), K = (e) => {
  const { promptbookId: a, children: f, storageConfig: m } = e, { fileClient: l, defaultFiles: d } = m || {}, [r, b] = w(!0), {
    data: s,
    error: p,
    isSuccess: g
  } = i({
    queryKey: ["storage", a],
    queryFn: () => S(l, d || []),
    refetchOnMount: !1,
    refetchOnWindowFocus: !1
  }), {
    data: n,
    error: y,
    isSuccess: P
  } = i({
    queryKey: ["db"],
    queryFn: async () => await R(),
    refetchOnMount: !1,
    refetchOnWindowFocus: !1
  }), u = g && P, t = p || y, o = F(null);
  C(() => {
    u && o.current === null && (o.current = {
      storage: s,
      db: n
    }, b(!1));
  }, [u, s, n]);
  const h = q(
    () => ({
      isLoading: t ? !1 : r,
      error: t,
      runtime: o.current
    }),
    [r, t]
  );
  return /* @__PURE__ */ x(c.Provider, { value: h, children: f });
}, W = () => {
  const e = v(c);
  if (!e)
    throw new Error("usePromptbookRuntime must be used within a PromptbookRuntimeProvider");
  return e;
};
export {
  K as PromptbookRuntimeProvider,
  W as usePromptbookRuntime
};
//# sourceMappingURL=index.js.map
